<template>
    <div class="row recent-orders submit-order-button">
        <div class="alert alert-danger" role="alert" v-if="error">
            {{ error }}
        </div>

        <div v-if="showForm">
            <direct-to-dealer-onboarding-form
                :id="id"
                @save="onFormSave"
            ></direct-to-dealer-onboarding-form>
        </div>
        <!-- <div v-else-if="iframeLink != null && !showForm">
            <div class="col-md-12 pb-3">
                <h3>Document Signing</h3>
                <p class="text-dark">
                    Please complete the following information that will be used
                    to create your Dealer Commission Program account.
                </p>
            </div>
            <iframe :src="this.iframeLink" class="w-full"></iframe>
        </div>
        <div v-else-if="iframeLink == null && !success && !showForm">
            <div class="loadarea">
                <div class="spinner-border text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <div class="text-center w-100 mt-3">
                    <template v-if="!hasSigned">
                        Initializing Signing Session
                    </template>
                    <template v-else> Saving Document Data </template>
                </div>
            </div>
        </div> -->
        <div v-else-if="agreement">
            <direct-to-dealer-agreement @confirm="confirmAgreement"></direct-to-dealer-agreement>
        </div>
        <div v-else-if="success">
            <direct-to-dealer-thank-you :onboardingstatus="onboarding_status"></direct-to-dealer-thank-you>
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import DirectToDealerOnboardingForm from "./forms/DirectToDealerOnboardingForm.vue";
import DirectToDealerThankYou from "./partials/DirectToDealerThankYou.vue";
import DirectToDealerAgreement from "./partials/DirectToDealerAgreement.vue";
export default {
    props: ["id"],
    emits: [],
    components: {
        DirectToDealerOnboardingForm,
        DirectToDealerThankYou,
        DirectToDealerAgreement
    },
    setup() {
        const store = useStore();
        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });

        let user = computed(function () {
            return store.state.user;
        });

        function setIsD2DUser() {
            store.commit("setIsD2DUser", true);
        }

        function checkIsD2DUser() {
            store.dispatch("getIsD2DUser");
        }

        return {
            store,
            currentLocation,
            user,
            setIsD2DUser,
            checkIsD2DUser,
        };
    },
    data() {
        return {
            iframeLink: null,
            signingSessionData: {},
            hasSigned: false,
            success: false,
            // success: true,
            showForm: true,
            // showForm: false,
            error: null,
            saving: false,
            d2dId: null,
            agreement: false,
            // agreement: true,
            onboarding_status: false
        };
    },
    mounted() {
      const params = new URLSearchParams(window.location.search);
      this.success = params.get('success');

      if (this.success) {
        this.showForm = false;
        this.agreement = false;
        this.onboarding_status = true;
      }
    },
    methods: {
        getIframeLink() {
            /**TESTING**/
            this.iframeLink =
                "https://app.pandadoc.com/s/6hKS7UdPwdng83H7qhC35a";

            window.addEventListener("message", (event) => {
                const type = event.data && event.data.type;
                const payload = event.data && event.data.payload;
                switch (type) {
                    case "session_view.document.loaded":
                        console.log("Session view is loaded");
                        break;
                    case "session_view.document.completed":
                        this.saveDocument(payload);
                        break;
                    case "session_view.document.exception":
                        console.log("Exception during document finalization");
                        console.log(payload);
                }
            });
        },

        // onFormSave(data) {
        //     if (data.id != undefined) {
        //         this.d2dId = data.id;
        //         this.iframeLink = data.link;
        //         this.showForm = false;
        //         window.addEventListener("message", (event) => {
        //             const type = event.data && event.data.type;
        //             const payload = event.data && event.data.payload;
        //             switch (type) {
        //                 case "session_view.document.loaded":
        //                     console.log("Session view is loaded");
        //                     break;
        //                 case "session_view.document.completed":
        //                     this.saveDocument(payload);
        //                     break;
        //                 case "session_view.document.exception":
        //                     console.log(
        //                         "Exception during document finalization"
        //                     );
        //             }
        //         });
        //     }
        // },

        onFormSave(data) {
          if (data.id != undefined) {
            this.d2dId = data.id;
            this.showForm = false;
            this.agreement = true;
          }
        },

        saveDealerInformation() {},

        // saveDocument(data) {
        //     this.signingSessionData = data;
        //     this.iframeLink = null;
        //     this.hasSigned = true;
        //     axios
        //         .post("/api/save-d2d-onboarding", {
        //             d2d_id: this.d2dId,
        //             signing_session_data: data,
        //         })
        //         .then((res) => {
        //             this.success = true;
        //             this.checkIsD2DUser();
        //         })
        //         .catch((err) => {
        //             this.error =
        //                 "Unable to finish contract signing, please contact the site administrator";
        //         });
        // },

        confirmAgreement(data) {
            window.emitter.emit("changeLoaderStatus", true);
            axios
                .post("/api/save-d2d-onboarding", {
                    d2d_id: this.d2dId,
                    onboarding_status: data,
                })
                .then((res) => {
                    this.showForm = false;
                    this.agreement = false;
                    const params = new URLSearchParams(window.location.search);
                    params.set('success', true);
                    window.location.href = window.location.pathname + '?' + params.toString();

                    this.onboarding_status = data;
                    this.checkIsD2DUser();
                    window.emitter.emit("changeLoaderStatus", false);
                })
                .catch((err) => {
                    this.error =
                        "Unable to finish contract signing, please contact the site administrator";
                });
        },
    },
};
</script>
<style scoped>
iframe,
.loadarea {
    width: 100%;
    height: 50em;
    background: #ececec;
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    justify-content: center;
}

.element-fadeinout {
    opacity: 0.8;
    animation: fade 1.5s infinite;
}

@keyframes fade {
    0%,
    100% {
        opacity: 0.4;
    }
    50% {
        opacity: 0.6;
    }
}
</style>
